import { clsx } from "clsx";

export type ButtonStyle = "primary" | "secondary" | "danger";

export default function buttonStyleClasses(
  style: ButtonStyle,
  dropdown?: boolean,
) {
  return clsx(
    `
      inline-block rounded-sm border border-solid px-3 py-1 text-center
      align-middle font-normal whitespace-nowrap no-underline transition-colors
      select-none
      not-disabled:cursor-pointer
      disabled:pointer-events-none disabled:opacity-70
    `,
    {
      "border-blue-600 bg-blue-600 text-white hover:border-sky-800 hover:bg-blue-700":
        style === "primary",
      "border-gray-500 bg-gray-500 text-white hover:border-gray-700 hover:bg-gray-600":
        style === "secondary",
      "border-red-600 bg-red-600 text-white hover:border-red-800 hover:bg-red-700":
        style === "danger",
      "after:ms-[0.255rem] after:inline-block after:border-x-[0.3rem] after:border-t-[0.3rem] after:border-b-0 after:border-x-transparent after:align-[0.255rem]":
        dropdown,
    },
  );
}
